module.exports = __webpack_public_path__ + "static/media/flodesk-icon.d792b0a0.svg";